import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class AccountTypesSelect extends Component {    

    constructor(props) {
        super(props);
        this.state = { accountTypes: [] };
        this.getAccountTypes = this.getAccountTypes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService()
    }

    componentDidMount() {
        this.getAccountTypes();
    }

    componentWillUnmount() {
    }

    getAccountTypes() {
        this.http.get('/api/Orders/GetAccountTypes', null).then(data=>{
            this.setState({ accountTypes: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.accountTypes.map((item) =>
            <option key={item.key} value={item.key}>{item.value}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default AccountTypesSelect
